<template>
  <v-container fluid>
    <payroll-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollReportContainerView: () => import('@/components/hris/payroll/report/ContainerView'),
    },
  }
</script>
